import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/Seo';

function NotFound() {
  return (
    <>
      <SEO 
        customData={{
          title: 'Page Not Found | Faheem Graphics',
          description: 'The page you are looking for does not exist. Return to our homepage.'
        }}
      />
      <div className="not-found">
        <h1>404 - Page Not Found</h1>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn btn-primary">Return to Homepage</Link>
      </div>
    </>
  );
}

export default NotFound;